import { render } from "./CustomerAgreement.vue?vue&type=template&id=38178cd4&scoped=true"
import script from "./CustomerAgreement.vue?vue&type=script&lang=js"
export * from "./CustomerAgreement.vue?vue&type=script&lang=js"

import "./CustomerAgreement.vue?vue&type=style&index=0&id=38178cd4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38178cd4"]])

export default __exports__